
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ViewerActorModel } from 'src/app/models/viewer/viewer-actor.model';


export const WithdrawnModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'lg',
  backdrop: 'static'
};

@Component({
    templateUrl: './performed-action-withdrawn.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PerformedActionWithdrawnModal {
  @Input() actions!: ViewerActorModel[];
  @Input() documents!: any[];
  @Input() requestStatus!: string;
  @Input() withdrawReason!: string;
}
